import { billingApi, stripeApi } from '@/api'

const convertPaymentMethodToStore = (method) => {
  return {
    label: `•••• ${method.card.lastFour}`,
    leftImage: `/static/card-logos/${method.card.brand}.png`,
    value: method.id,
  }
}

export default {
  addPaymentMethod: async ({ commit }, method) => {
    const newPaymentMethod = {
      label: `•••• ${method.card.lastFour}`,
      leftImage: `/static/card-logos/${method.card.brand}.png`,
      value: method.id,
    }

    commit('ADD_PAYMENT_METHOD', newPaymentMethod)

    return method.paymentMethod
  },
  createPaymentMethod: async ({ commit }, { cardNumber, brandId }) => {
    const { paymentMethod } = await stripeApi.createPaymentMethod(cardNumber)

    await billingApi.createPaymentMethod({
      brandId,
      paymentMethodId: paymentMethod.id,
    })

    const newPaymentMethod = {
      label: `•••• ${paymentMethod.card.last4}`,
      leftImage: `/static/card-logos/${paymentMethod.card.brand}.png`,
      value: paymentMethod.id,
    }

    commit('ADD_PAYMENT_METHOD', newPaymentMethod)

    return paymentMethod.id
  },
  populatePaymentMethods: async ({ commit }, { brandId }) => {
    const { paymentMethods } = await billingApi.getPaymentMethods({
      brandId,
    })

    if (paymentMethods && paymentMethods.length) {
      commit(
        'SET_PAYMENT_METHODS',
        paymentMethods.map(convertPaymentMethodToStore)
      )
    }
  },
  resetPaymentMethods: ({ commit }) => {
    commit('RESET_PAYMENT_METHODS')
  },
}
